import { InputTextarea } from 'primereact/inputtextarea';
import React, { FocusEvent, useState } from 'react';
import { Trans } from 'react-i18next';

interface AdditionalInfoTextareaProps {
    value: string;
    onChange: (e: FocusEvent<HTMLTextAreaElement>) => void;
    onBlur?: (e: FocusEvent<HTMLTextAreaElement>) => void;
    onFocus?: (e: FocusEvent<HTMLTextAreaElement>) => void;
    className?: string;
    placeholder?: string;
    richPlaceholder?: boolean;
    withFloatingLabel?: boolean;
    rows?: number;
    cols?: number;
    autoResize?: boolean;
    name?: string;
    id?: string;
}

const AdditionalInfoTextarea: React.FC<AdditionalInfoTextareaProps> = ({
    value,
    onChange,
    onBlur,
    onFocus,
    className,
    placeholder,
    richPlaceholder = false,
    withFloatingLabel = false,
    rows,
    cols,
    autoResize,
    name,
    id,
}) => {
    const [focused, setFocused] = useState(false);
    const showRichPlaceholder = richPlaceholder && !value && !focused;

    return (
        <div className={`additional-info-textarea-wrapper${withFloatingLabel ? ' with-floating-label' : ''}`}>
            <InputTextarea
                value={value}
                onChange={onChange}
                onBlur={(e) => {
                    setFocused(false);
                    onBlur?.(e);
                }}
                onFocus={(e) => {
                    setFocused(true);
                    onFocus?.(e);
                }}
                className={className}
                placeholder={richPlaceholder ? '' : placeholder}
                rows={rows}
                cols={cols}
                autoResize={autoResize}
                name={name}
                id={id}
            />
            {showRichPlaceholder && (
                <div className="additional-info-custom-placeholder" aria-hidden="true">
                    <Trans i18nKey="tabs.additional_info_placeholder" />
                </div>
            )}
        </div>
    );
};

export default AdditionalInfoTextarea;
